import { TileLayout } from '@progress/kendo-react-layout';
import type { DashboardProps } from './dashboard.types.ts';
import styles from './dashboard.module.scss';

export function Dashboard({ className, columns, items }: DashboardProps) {
  return (
    <div className={styles.container}>
      <TileLayout className={`${styles.dashboard} ${className}`} columns={columns} items={items} />
    </div>
  );
}
